import { Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ViewUserComponent } from './pages/user/view-user/view-user.component';
import { ViewFilesComponent } from './pages/files/view-files/view-files.component';
import { ViewProductComponent } from './pages/product/view-product/view-product.component';
import { ViewSdkComponent } from './pages/sdk/view-sdk/view-sdk.component';
import { EmailComposerComponent } from './pages/email/composer/email-composer.component';
import { SecureDownloadComponent } from './pages/secure-download/secure-download.component';
import { ViewEmailComponent } from './pages/email/view-email/view-email.component';
import { permissionGuard } from './services/permission-guard/permission.guard';
import { PermissionEnum } from './dto';
import { UnauthorizedAccessComponent } from './components/unauthorized-access/unauthorized-access.component';

export const routes: Routes = [
	{ path: '', redirectTo: 'dashboard', pathMatch: 'full' },
	{ path: 'unauthorized', component: UnauthorizedAccessComponent },
	{ path: 'dashboard', component: DashboardComponent },
	{ path: 'user/view-user', component: ViewUserComponent, canActivate: [permissionGuard(PermissionEnum.UsersView)] },
	{ path: 'product/view-product', component: ViewProductComponent, canActivate: [permissionGuard(PermissionEnum.ProductsView)] },
	{ path: 'sdk/view-sdk', component: ViewSdkComponent, canActivate: [permissionGuard(PermissionEnum.SdksView)] },
	{ path: 'email', component: EmailComposerComponent, canActivate: [permissionGuard(PermissionEnum.EmailCompose)] },
	{ path: 'email/view', component: ViewEmailComponent, canActivate: [permissionGuard(PermissionEnum.EmailView)] },
	{ path: 'files/view-files', component: ViewFilesComponent, canActivate: [permissionGuard(PermissionEnum.FilesBrowse)] },
	{ path: 'secure-download', component: SecureDownloadComponent },
	{ path: 'secure-download/:uuid', component: SecureDownloadComponent },
	{ path: '**', redirectTo: 'dashboard' }
];
